import React from 'react';

import { BinClosedIcon } from '@depop/web-ui-kit/Icons/BinClosedIcon';
import { useTranslations } from 'next-intl';

import { ButtonMinimal } from '@/components/ButtonMinimal';
import { ErrorMessage } from '@/components/ErrorMessage';
import { Spinner } from '@/components/Spinner';
import { type DetailedBagProduct } from '@/modules/bag/aliases';
import { useDeleteFromBag } from '@/modules/bag/useDeleteFromBag';

type Props = {
  product: DetailedBagProduct;
  sellerId: number;
};

function BagDeleteProductButton({ product, sellerId }: Props) {
  const t = useTranslations('bag');

  const { deleteFromBag, isDeletingOrDeleted, errorText } = useDeleteFromBag();

  function handleDeleteClick() {
    deleteFromBag([
      {
        product_id: product.id,
        variant_id: product.variant_id || undefined,
        quantity: 0,
        seller_id: sellerId,
      },
    ]);
  }

  return isDeletingOrDeleted ? (
    <Spinner />
  ) : (
    <>
      <ButtonMinimal onClick={handleDeleteClick}>
        {/* Svg has padding on it so have to play with the viewBox to get it to align */}
        <BinClosedIcon
          title={t('Bag.DeleteProduct.Title')}
          viewBox="3 3 24 24"
        />
      </ButtonMinimal>
      {errorText && <ErrorMessage>{errorText}</ErrorMessage>}
    </>
  );
}

export { BagDeleteProductButton };
